export const ExpandDownIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path d='M20 8L12 16L4 8' stroke='currentColor' strokeWidth='2' />
    </svg>
);
